import { Api } from '../helpers';

const valetModel = {
  getValetData(params) {
    const queryParams = params;
    const path = 'logistics/get_valet_info';
    return Api.get({ path, queryParams });
  },
  getValetNumber(params) {
    const queryParams = params;
    const path = 'logistics/get_number';
    return Api.get({ path, queryParams });
  },

  getDPAssignedUnassignedNumbers(params) {
    const queryParams = params;
    const path = 'logistics/get_dp_assigned_unassigned_numbers';
    return Api.get({ path, queryParams });
  },

  getCallLogsDetails(params) {
    const queryParams = params;
    const path = 'logistics/get_call_logs';
    return Api.get({ path, queryParams });
  },

  getAssignments(url, params) {
    const queryParams = params;
    const path = `logistics/${url}`;
    return Api.get({ path, queryParams });
  },
};

export default valetModel;
